import { render, staticRenderFns } from "./HardwareDetails.vue?vue&type=template&id=16e08fe2&scoped=true&"
import script from "./HardwareDetails.vue?vue&type=script&lang=js&"
export * from "./HardwareDetails.vue?vue&type=script&lang=js&"
import style0 from "./HardwareDetails.vue?vue&type=style&index=0&id=16e08fe2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e08fe2",
  null
  
)

export default component.exports